import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/app/industries/components/IndustriesInteractive.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/components/common/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/components/ui/AppIcon.tsx");
